import { FontWeight } from '@y42/json-schema';
import * as go from 'gojs';
import { GojsFont } from '../models/gojs-font.model';

const fontRegex = /(?<fontWeight>normal|bold) (?<fontSize>\d+)px (?<fontFamily>.+)/;

export const gojsDataToFontModel = (data: go.ObjectData, fontProp: string): GojsFont => {
  const fontInfo = data[fontProp].match(fontRegex);

  if (!fontInfo) {
    return {
      fontFamily: '',
      fontWeight: FontWeight.Normal,
      fontSize: 10,
    };
  }

  return {
    fontFamily: fontInfo.groups['fontFamily'],
    fontWeight: fontInfo.groups['fontWeight'],
    fontSize: +fontInfo.groups['fontSize'],
  };
};

export const fontModelToGojsData = ({ fontFamily, fontWeight, fontSize }: GojsFont, fontProp: string) => ({
  [fontProp]: `${fontWeight} ${fontSize}px ${fontFamily}`,
});

export const updateGojsFontWeight = (data: go.ObjectData, fontProp: string, fontWeight: FontWeight) => {
  const { fontSize, fontFamily } = gojsDataToFontModel(data, fontProp);

  return `${fontWeight} ${fontSize}px ${fontFamily}`;
};

export const updateGojsFontSize = (data: go.ObjectData, fontProp: string, fontSize: number) => {
  const { fontWeight, fontFamily } = gojsDataToFontModel(data, fontProp);

  return `${fontWeight} ${fontSize}px ${fontFamily}`;
};

export const updateGojsFontFamily = (data: go.ObjectData, fontProp: string, fontFamily: string) => {
  const { fontSize, fontWeight } = gojsDataToFontModel(data, fontProp);

  return `${fontWeight} ${fontSize}px ${fontFamily}`;
};
